import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-page-title',
  standalone: false,
  templateUrl: './pagetitle.component.html',
  styleUrls: ['./pagetitle.component.scss']
})
export class PagetitleComponent implements OnInit {
  @Input() breadcrumbItems;
  @Input() title: string;

  constructor(private translateService: TranslateService, ) { }

  ngOnInit() {
    if (this.breadcrumbItems) {
      this.breadcrumbItems.forEach((item, index) => {
        this.translateService.get(item.label).subscribe((translation: string) => {
          this.breadcrumbItems[index].label = translation;
        });
      });
    }
  }

}